import { render, staticRenderFns } from "./OneDriveFileIcon.vue?vue&type=template&id=710ccade&"
import script from "./OneDriveFileIcon.vue?vue&type=script&lang=js&"
export * from "./OneDriveFileIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB03-CV-02\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('710ccade')) {
      api.createRecord('710ccade', component.options)
    } else {
      api.reload('710ccade', component.options)
    }
    module.hot.accept("./OneDriveFileIcon.vue?vue&type=template&id=710ccade&", function () {
      api.rerender('710ccade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/static/Images/OneDriveFileIcon.vue"
export default component.exports